import { useCallback } from "react";
import { useTaskpaneServices } from "@src/load-agent/app/TaskpaneServicesContext";
import { runOpenReplyDraftFlow, type OpenReplyDraftOptions } from "./openReplyDraftRunner";

export type { OpenReplyDraftOptions };

export function useOpenReplyDraft() {
  const { loadApp } = useTaskpaneServices();

  return useCallback(
    (options: OpenReplyDraftOptions) => {
      runOpenReplyDraftFlow(loadApp, options);
    },
    [loadApp]
  );
}
